<template>
    <el-dialog
        title="更换手机号"
        :visible.sync="visible"
        width="850px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose">
        <div>
            <el-steps :active="active" align-center>
                <el-step title="解绑旧手机"></el-step>
                <el-step title="输入新手机号"></el-step>
                <el-step title="验证新手机号"></el-step>
                <el-step title="绑定完成"></el-step>
            </el-steps>
            <el-alert
                v-if="quota"
                class="quota-tip"
                :title="quota.message"
                type="info"
                :closable="false"
                show-icon>
            </el-alert>
            <div class="step-zero" v-show="active===0">
                <div class="verify">
                    <div class="send-tip">
                        系统将向手机号<span class="phone">{{ showPhone }}</span>发送验证码 &nbsp;&nbsp;&nbsp; <span
                        v-show="zero.left>0">{{ zero.left }}S</span>
                        <el-link v-show="zero.left===0" type="primary" @click="unbindOldPhone">发送</el-link>
                    </div>
                    <verify-code v-show="zero.send" @done="codeUnbindInputOk"></verify-code>
                </div>
            </div>
            <div class="step-one" v-show="active===1">
                <div v-show="error.one">
                    <el-result icon="error" title="新手机号检查不通过">
                        <template slot="extra">
                            <div class="tip">
                                <p>此账号注销状态中</p>
                                <p>此手机号手机会员时间还没有过期</p>
                                <p>此手机号Bigemap Pro 会员还没有过期</p>
                                <p class="text">
                                    可联系Bigemap客服确认
                                </p>
                            </div>
                        </template>
                    </el-result>
                </div>
                <div class="input-area">
                    <div class="input">
                        <el-input v-model="newPhone" placeholder="请输入要绑定的新手机号"></el-input>
                    </div>
                    <div class="bu">
                        <el-button @click="checkNewPhone" type="primary">验证新手机号</el-button>
                    </div>
                </div>
            </div>
            <div class="step-two" v-show="active===2">
                <div class="verify">
                    <verify-code @done="codeInputOk"></verify-code>
                    <div class="left-time" v-show="two.left>0">{{ two.left }}S后重新获取验证码</div>
                    <div class="re-send" v-show="two.left===0">
                        <el-link type="primary" @click="reSend">重新发送</el-link>
                    </div>
                </div>
            </div>
            <div class="step-done" v-show="active===3">
                <el-result icon="success" title="绑定完成" subTitle="你可以使用新手机号登录了">
                    <template slot="extra">
                        <el-button type="primary" @click="changeOk" size="medium">我知道了</el-button>
                    </template>
                </el-result>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import VerifyCode from "@/components/user/profile/verify-code.vue";

export default {
    components: {
        VerifyCode,
    },
    props: ['show', 'quota'],
    data() {
        return {
            baseUrl: '/bbs/user/cPhone',
            baseVerifyUrl: '/bbs/user/vPhone',
            baseUnbindUrl: '/bbs/user/unPhone',
            visible: false,
            active: 0,
            error: {
                one: false,
            },
            zero: {
                left: 0,
                timer: '',
                send: false,
            },
            two: {
                left: 10,
                timer: '',
            },
            newPhone: '',
        }
    },
    computed: {
        showPhone: function () {
            let phone = this.$store.state.userData.phone;
            return '1** ****' + phone.substr(-4);
        }
    },
    watch: {
        show: {
            immediate: true,
            handler: function (v) {
                this.visible = v;
            }
        }
    },
    methods: {
        changeOk() {
            this.beforeClose();
            location.reload();
        },
        beforeClose() {
            this.newPhone = '';
            this.active = 0;
            this.two.left = 10;
            this.error.one = false;
            clearInterval(this.two.timer);
            // clearInterval(this.zero.timer);
            this.$emit('change', {type: 'close'});
        },
        unbindOldPhone() {
            if (this.$store.state.loading) return;
            this.$bbs.post(this.baseUnbindUrl, {}, {need: {error: true}}).then(() => {
                this.checkUnbindTime();
            });
        },
        checkNewPhone() {
            if (!this.newPhone) return;
            this.$bbs.post(this.baseUrl, {phone: this.newPhone}, {need: {error: true}}).then(data => {
                this.active = 2;
                this.error.one = false;
                this.checkTime();
            }).catch(e => {
                if (e.data && e.data.code === 1410) {
                    this.error.one = true;
                }
            });
        },
        reSend() {
            //其实重发就是重新提交一次手机号
            this.checkNewPhone();
        },
        codeUnbindInputOk(info) {
            this.$bbs.put(this.baseUnbindUrl, {
                code: info.code,
            }, {need: {error: true}}).then(() => {
                this.active = 1;
                this.checkUnbindTime(true);
            });
        },
        codeInputOk(info) {
            this.$bbs.post(this.baseVerifyUrl, {
                code: info.code,
                phone: this.newPhone
            }, {need: {error: true}}).then(data => {
                this.$message.success('操作成功!');
                this.active = 3;
            });
        },
        checkUnbindTime(is_done=false) {
            if (is_done){
                this.zero.left = 0;
                clearInterval(this.zero.timer);
            }else{
                this.zero.left = 120;
                this.zero.send = true;
                this.zero.timer = setInterval(() => {
                    this.zero.left--;
                    if (this.zero.left <= 0) {
                        clearInterval(this.zero.timer);
                    }
                }, 1000);
            }
        },
        checkTime() {
            this.two.left = 120;
            this.two.timer = setInterval(() => {
                this.two.left--;
                if (this.two.left <= 0) {
                    clearInterval(this.two.timer);
                }
            }, 1000);
        },
    }
}

</script>
<style scoped lang="less">
.quota-tip {
    width: 560px;
    margin: 20px auto 0;
}

.step-one {
    padding: 40px 100px;

    .input-area {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .input {
            width: 70%;
        }

        .bu {
            width: 20%;
        }
    }
}

.step-zero, .step-two {
    .verify {
        width: 320px;
        margin: 0 auto;

        .left-time, .re-send {
            padding: 15px;
            text-align: center;
        }
    }
}

.step-zero {
    padding-top: 20px;

    .verify {
        width: 400px;
    }

    .send-tip {
        display: flex;
        align-items: center;

        .phone {
            font-weight: bold;
            display: inline-block;
            padding: 0 10px;
        }
    }
}

.tip {
    .text {
        color: #333;
    }

    line-height: 25px;
    text-align: left;
}
</style>
